import type { SVGProps } from 'react';

export function FrogIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 3.6a3 3 0 0 1 2.989 2.719l3.21.986a2.273 2.273 0 0 1 .453 4.148l-5.418 3.078 3.468 3.47h1.902c.663 0 1.2.535 1.2 1.2 0 .663-.537 1.2-1.2 1.2h-2.4c-.319 0-.623-.128-.848-.353l-4.147-4.14a3.9 3.9 0 0 0-.953-3.964 3.896 3.896 0 0 0-5.509-.004l-2.76 2.625a.599.599 0 1 0 .825.87l2.768-2.632.008-.008q.197-.197.423-.345a2.7 2.7 0 0 1 3.394.345 2.703 2.703 0 0 1 0 3.818L11.018 18H14.4c.664 0 1.2.536 1.2 1.2s-.536 1.2-1.2 1.2H3.6A2.4 2.4 0 0 1 1.2 18c0-6.24 4.763-11.366 10.849-11.944A3 3 0 0 1 15 3.6m0 3.9c.499 0 .9-.401.9-.9s-.401-.9-.9-.9-.9.401-.9.9.401.9.9.9" />
    </svg>
  );
}
